import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Button,
    Chip,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    IconButton,
    Tabs,
    Tab
} from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DirectionsBikeIcon from '@mui/icons-material/Moped';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import Services from '../services/Services';

import { useRef } from 'react';
import { tokenService } from 'src/services';

export default function EsnafCourierCargo() {
    const [paymentFormErrors, setPaymentFormErrors] = useState({});
    const [courierModalOpen, setCourierModalOpen] = useState(false);
    const [cargoModalOpen, setCargoModalOpen] = useState(false);
    const [cancelModalOpen, setCancelModalOpen] = useState(false);
    const [deliveryModalOpen, setDeliveryModalOpen] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [activeTab, setActiveTab] = useState('active');
    const [step, setStep] = useState(0);
    const [selectedCompany, setSelectedCompany] = useState('');
    const [requestType, setRequestType] = useState('');
    // --- API'den gelen talepler için state ---
    const [courierRequests, setCourierRequests] = useState([]); // Vigo
    const [cargoRequests, setCargoRequests] = useState([]); // Kargoist
    const [cargoLabelData, setCargoLabelData] = useState(null);

    const companies = {
        kurye: ['Vigo'],
        kargo: ['Kargoist']
    };

    const [formData, setFormData] = useState({
        // TEST DATA - Geliştirme sırasında otomatik doldurulur, yayına alınırken kaldırılacak
        gondericiAd: "",
        gondericiSoyad: "",
        telefon: "",
        email: "",
        tckn: "",
        bireyselKurumsal: "Bireysel",
        icerikKategori: "",
        paketAdedi: "",
        agirlik: "",
        city: "",
        district: "",
        town: "",
        aliciAdSoyad: "",
        aliciAd: "",       // (Kargoist için)
        aliciSoyad: "",    // (Kargoist için)
        aliciTelefon: "",
        gondericiCity: "", // (Kargoist için) 
        gondericiTown: "", // (Kargoist için)
        gondericiAcikAdres: "", // (Kargoist için)
        acikAdres: "",
        kuryeModel: "",
        adresTarifi: "",
        additionalNote: ""
    });
    const [formErrors, setFormErrors] = useState({});
    const [cities, setCities] = useState([]);
    const [towns, setTowns] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [gondericiTowns, setGondericiTowns] = useState([]);
    const [token, setToken] = useState('');
    const [isPaymentCompleted, setIsPaymentCompleted] = useState(false);
    const [selectedRequestId, setSelectedRequestId] = useState(null);
    const [mapModalOpen, setMapModalOpen] = useState(false);
    const [addressNotFoundModalOpen, setAddressNotFoundModalOpen] = useState(false);
    const [selectedLatLng, setSelectedLatLng] = useState(null);
    const [showLocationConfirmModal, setShowLocationConfirmModal] = useState(false);
    const [pendingLatLng, setPendingLatLng] = useState(null);
    const [vigoPriceDetails, setVigoPriceDetails] = useState(null);
    const [cargoPriceDetails, setCargoPriceDetails] = useState(null); // Kargoist State
    const [isCalculating, setIsCalculating] = useState(false);
    const [paymentModalOpen, setPaymentModalOpen] = useState(false);
    const [paymentToken, setPaymentToken] = useState('');
    const [paymentTokenLoading, setPaymentTokenLoading] = useState(false);
    const [paymentTokenError, setPaymentTokenError] = useState('');
    const [cardName, setCardName] = useState("");
    const [cardNumber, setCardNumber] = useState("");
    const [expiredDate, setExpiredDate] = useState("");
    const [cvv, setCvv] = useState("");
    const [conversationID, setConversationID] = useState("");
    const [iframeSrc, setIframeSrc] = useState(null);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const intervalRef = useRef(null);
    const [summaryAddress, setSummaryAddress] = useState("");
    const [orderLoading, setOrderLoading] = useState(false);
    const [paymentType, setPaymentType] = useState(''); // Nakit, Fiziki Pos, Online
    const [cashPosModalOpen, setCashPosModalOpen] = useState(false); // yeni modal için
    const [pendingPaymentType, setPendingPaymentType] = useState(''); // hangi tipte ödeme bekleniyor
    const [cargoPackages, setCargoPackages] = useState([]);
    const [currentPackage, setCurrentPackage] = useState({
        icerikKategori: '',
        agirlik: '',
        en: '',
        boy: '',
        yukseklik: ''
    });

    useEffect(() => {
        const fetchTokenAndCities = async () => {
            try {
                const newToken = JSON.parse(localStorage.getItem('user'))?.token;
                if (!newToken) return;
                setToken(newToken);

                const citiesRes = await Services.GetCities();
                setCities(citiesRes.data.result || []);
            } catch (error) {
                console.error('Error fetching token or cities:', error);
                setCities([]);
            }
        };

        fetchTokenAndCities();
    }, []);

    useEffect(() => {
        if (!token || !formData.gondericiCity) {
            setGondericiTowns([]);
            setFormData(prev => ({ ...prev, gondericiTown: '' }));
            return;
        }

        const selectedCity = cities.find(c => c.name === formData.gondericiCity);
        if (!selectedCity) return;

        const fetchGondericiTowns = async () => {
            try {
                const res = await Services.GetTowns(selectedCity.code);
                setGondericiTowns(res.data.result || []);
            } catch (error) {
                console.error('Error fetching sender towns:', error);
                setGondericiTowns([]);
            }
        };

        fetchGondericiTowns();
    }, [formData.gondericiCity, cities]);


    useEffect(() => {
        if (!token || !formData.city) return;

        const selectedCity = cities.find(c => c.name === formData.city);
        if (!selectedCity) return;

        const fetchTowns = async () => {
            try {
                const res = await Services.GetTowns(selectedCity.code);
                setTowns(res.data.result || []);
            } catch (error) {
                console.error('Error fetching towns:', error);
                setTowns([]);
            }
        };

        fetchTowns();
    }, [token, formData.city, cities]);

    useEffect(() => {
        if (!token || !formData.district) return;

        const selectedTown = towns.find(t => t.name === formData.district);
        if (!selectedTown) return;

        const fetchDistricts = async () => {
            try {
                const res = await Services.GetRegions(selectedTown.code);
                setDistricts(res.data.result || []);
            } catch (error) {
                console.error('Error fetching districts:', error);
                setDistricts([]);
            }
        };

        fetchDistricts();
    }, [token, formData.district, towns]);

    useEffect(() => {
        if (paymentModalOpen) {
            setPaymentToken('');
            setPaymentTokenError('');
            setPaymentTokenLoading(false);
        }
    }, [paymentModalOpen]);

    useEffect(() => {
        // conversationID değiştiğinde ve doluysa ödeme başlat
        if (conversationID) {
            // Fiyatı vigoPriceDetails.price'tan al
            const price = requestType === 'kargo'
                ? cargoPriceDetails?.price
                : vigoPriceDetails?.price || 0;
            // Dummy isimler, gerçek isimler localStorage'dan alınabilir veya formdan
            Services.PaymentWith3D(
                conversationID,
                price,
                formData.gondericiAd,
                formData.gondericiSoyad,
                formData.telefon,
                cardName,
                cardNumber,
                expiredDate.slice(-2), // YY
                expiredDate.slice(0, 2), // AA
                cvv
            ).then((res) => {
                if (res.data.status) {
                    console.log("Res Data : ", res.data)
                    const htmlContent = res.data.result;
                    const blob = new Blob([htmlContent], { type: 'text/html' });
                    const url = URL.createObjectURL(blob);
                    setIframeSrc(url);
                } else {
                    setIframeSrc(null);
                }
            }).catch(() => {
                setIframeSrc(null);
            });
        }
        // Temizlik: modal kapanınca iframe'i sıfırla
        if (!paymentModalOpen) {
            setIframeSrc(null);
        }
        // eslint-disable-next-line
    }, [conversationID, paymentModalOpen]);

    useEffect(() => {
        if (iframeSrc && conversationID) {
            intervalRef.current = setInterval(() => {
                Services.ListenPayment(conversationID)
                    .then(async (res) => {
                        // Ödeme başarılıysa
                        if (res.data.status && res.data.result === "1") {
                            clearInterval(intervalRef.current);
                            setIframeSrc(null);
                            setShowSuccessModal(false);
                            setOrderLoading(true);

                            try {
                                const pointID = tokenService.getUser().firstResponsibleOffice.id;
                                let apiResponse;

                                // ================= KARGO GÖNDERİSİ OLUŞTURMA =================
                                if (requestType === 'kargo') {
                                    const cargoData = {
                                        pointID,
                                        senderName: formData.gondericiAd,
                                        senderLastname: formData.gondericiSoyad,
                                        senderPhone: formData.telefon,
                                        senderEmail: formData.email,
                                        senderAddressCity: formData.gondericiCity,
                                        senderAddressTown: formData.gondericiTown, // İlçe
                                        senderAddressDetails: formData.gondericiAcikAdres,
                                        receiverName: formData.aliciAd,
                                        receiverLastname: formData.aliciSoyad,
                                        receiverAddressNeighbour: formData.town, // Mahalle
                                        receiverAddressTown: formData.district, // İlçe
                                        receiverAddressCity: formData.city,
                                        receiverAddressDetails: formData.acikAdres,
                                        receiverAddressDefinition: formData.adresTarifi,
                                        receiverPhone: formData.aliciTelefon,
                                        receiverEmail: formData.email, // Alıcı email'i formda yok, gönderici email'i kullanılabilir
                                        receiverZipcode: "34000", // Gerekirse bu alanı forma ekleyin
                                        price: cargoPriceDetails.price,
                                        productType: cargoPackages[0]?.icerikKategori || "Diğer",
                                        additionalNote: formData.additionalNote,
                                        paymentMethod: "online-payment",
                                        totalDeci: cargoPriceDetails.totalDesi,
                                        partCount: cargoPackages.map(pkg => ({ deci: parseFloat(pkg.agirlik) || 0 }))
                                    };
                                    apiResponse = await Services.createCargoistPost(cargoData);
                                }
                                // ================= KURYE GÖNDERİSİ OLUŞTURMA =================
                                else if (requestType === 'kurye') {
                                    const vigoData = {
                                        pointID,
                                        senderName: formData.gondericiAd,
                                        senderLastname: formData.gondericiSoyad,
                                        senderPhone: formData.telefon,
                                        senderEmail: formData.email,
                                        receiverNameLastname: formData.aliciAdSoyad,
                                        receiverAddressNeighbour: formData.town,
                                        receiverAddressTown: formData.district,
                                        receiverAddressCity: formData.city,
                                        receiverAddressDetails: formData.acikAdres,
                                        receiverAddressDefinition: formData.adresTarifi,
                                        receiverPhone: formData.aliciTelefon,
                                        price: vigoPriceDetails?.price || 0,
                                        longitude: selectedLatLng?.lng || '',
                                        latitude: selectedLatLng?.lat || '',
                                        productType: formData.icerikKategori,
                                        additionalNote: formData.additionalNote,
                                        courierType: formData.kuryeModel || 'MotorCourier',
                                        coupon: false,
                                        discountedPrice: 0
                                    };
                                    apiResponse = await Services.createVigoPost(vigoData);
                                }

                                // Ortak Başarı Durumu
                                if (apiResponse && apiResponse.data && apiResponse.data.status) {
                                    if (requestType === 'kargo') {
                                        // YENİ: Kargo yanıtından etiket bilgisini al ve state'e ata
                                        const labelInfo = apiResponse.data.result?.label?.[0];
                                        if (labelInfo) {
                                            setCargoLabelData(labelInfo); // Base64 ve gönderi numarasını sakla
                                            setSelectedRequestId(labelInfo.consignmentNumber); // Gönderi kodunu güncelle
                                        } else {
                                            // Etiket gelmezse bile barkodu gönderi kodu olarak kullan
                                            setSelectedRequestId(apiResponse.data.result?.barcode || 'No-ID');
                                        }
                                    } else { // Kurye için eski mantık devam ediyor
                                        const orderNumber = apiResponse.data.result?.orders?.[0]?.orderNumber || apiResponse.data.result?.orderIds?.[0];
                                        setSelectedRequestId(orderNumber || apiResponse.data.result?.id || '');
                                    }

                                    setPaymentModalOpen(false);
                                    setIsPaymentCompleted(true);
                                    setStep(2);
                                } else {
                                    throw new Error("API sipariş oluşturamadı.");
                                }

                            } catch (e) {
                                console.error("Gönderi oluşturma hatası:", e);
                                setOrderLoading(false);
                                setShowErrorModal(true);
                                setErrorMessage("Sipariş oluşturulurken bir hata oluştu.");
                            } finally {
                                setOrderLoading(false);
                            }
                        }
                        // Ödeme başarısızsa
                        else if (res.data.result === "2") {
                            clearInterval(intervalRef.current);
                            setIframeSrc(null);
                            setShowErrorModal(true);
                            setErrorMessage("Ödeme başarısız. Lütfen tekrar deneyin.");
                        }
                    })
                    .catch(err => {
                        console.error("Ödeme dinleme hatası:", err);
                        clearInterval(intervalRef.current);
                        setShowErrorModal(true);
                        setErrorMessage("Ödeme durumu kontrol edilirken bir sorun oluştu.");
                    });
            }, 3000);
        }

        // Temizlik fonksiyonu
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [
        iframeSrc,
        conversationID,
        formData,
        requestType,
        vigoPriceDetails,
        cargoPriceDetails,
        cargoPackages,
        selectedLatLng // Kurye gönderisi için bu da gerekli
    ]);

    useEffect(() => {
        // Summary ekranı açıldığında ters geocode ile adresi çek
        if (isPaymentCompleted && step === 2 && selectedLatLng) {
            const apiKey = "AIzaSyByvfX7mgCvxiti1aSmeZ3xs3-up0HWCB0";
            fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${selectedLatLng.lat},${selectedLatLng.lng}&key=${apiKey}`)
                .then(res => res.json())
                .then(data => {
                    if (data.status === 'OK' && data.results.length > 0) {
                        setSummaryAddress(data.results[0].formatted_address);
                    } else {
                        setSummaryAddress("");
                    }
                })
                .catch(() => setSummaryAddress(""));
        }
        // Temizlik: summary kapanınca adresi sıfırla
        if (!isPaymentCompleted || step !== 2) {
            setSummaryAddress("");
        }
    }, [isPaymentCompleted, step, selectedLatLng]);

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setFormErrors(prev => ({ ...prev, [name]: '' }));
    };

    const validateForm = () => {
        const errors = {};
        console.log('Validasyon başladı, formData:', formData);

        if (!formData.gondericiAd) {
            errors.gondericiAd = 'Gönderici adı zorunludur';
            console.log('Hata: gondericiAd');
        }
        if (!formData.gondericiSoyad) {
            errors.gondericiSoyad = 'Gönderici soyadı zorunludur';
            console.log('Hata: gondericiSoyad');
        }
        if (!formData.telefon) {
            errors.telefon = 'Telefon zorunludur';
            console.log('Hata: telefon');
        } else {
            const phone = formData.telefon.replace(/\D/g, '');
            if (!(phone.length === 10 || phone.length === 11)) {
                errors.telefon = 'Telefon numarası 10 veya 11 haneli olmalı';
                console.log('Hata: telefon uzunluğu');
            } else if (!/^\d+$/.test(phone)) {
                errors.telefon = 'Telefon numarası sadece rakamlardan oluşmalı';
                console.log('Hata: telefon formatı');
            }
        }
        if (!formData.email) {
            errors.email = 'E-posta zorunludur';
            console.log('Hata: email');
        }
        if (!formData.bireyselKurumsal) {
            errors.bireyselKurumsal = 'Gönderi tipi zorunludur';
            console.log('Hata: bireyselKurumsal');
        }
        if (!formData.city) {
            errors.city = 'İl zorunludur';
            console.log('Hata: city');
        }
        if (!formData.district) {
            errors.district = 'İlçe zorunludur';
            console.log('Hata: district');
        }
        if (!formData.town) {
            errors.town = 'Mahalle zorunludur';
            console.log('Hata: town');
        }
        if (requestType !== 'kargo') {
            if (!formData.aliciAdSoyad) {
                errors.aliciAdSoyad = 'Alıcı ad soyad zorunludur';
            } else {
                const parts = formData.aliciAdSoyad.trim().split(/\s+/);
                if (parts.length < 2) {
                    errors.aliciAdSoyad = 'Lütfen ad ve soyad giriniz';
                }
            }
        }
        if (!formData.aliciTelefon) {
            errors.aliciTelefon = 'Alıcı telefon zorunludur';
            console.log('Hata: aliciTelefon');
        } else {
            const phone = formData.aliciTelefon.replace(/\D/g, '');
            if (!(phone.length === 10 || phone.length === 11)) {
                errors.aliciTelefon = 'Telefon numarası 10 veya 11 haneli olmalı';
                console.log('Hata: aliciTelefon uzunluğu');
            } else if (!/^\d+$/.test(phone)) {
                errors.aliciTelefon = 'Telefon numarası sadece rakamlardan oluşmalı';
                console.log('Hata: aliciTelefon formatı');
            }
        }
        if (!formData.acikAdres) {
            errors.acikAdres = 'Açık adres zorunludur';
            console.log('Hata: acikAdres');
        }
        if (requestType === 'kargo') {

            if (cargoPackages.length === 0) {
                errors.packages = 'Lütfen en az bir paket ekleyin.';
                alert('Lütfen en az bir paket ekleyin.'); // Kullanıcıyı uyarmak için
            }

            if (!formData.aliciAd) {
                errors.aliciAd = 'Alıcı adı zorunludur';
            }
            if (!formData.aliciSoyad) {
                errors.aliciSoyad = 'Alıcı soyadı zorunludur';
            }
            if (!formData.tckn) {
                errors.tckn = 'TCKN zorunludur';
            } else {
                const tckn = formData.tckn.replace(/\D/g, '');
                if (tckn.length !== 11) {
                    errors.tckn = 'TCKN 11 haneli olmalı';
                } else if (!/^\d+$/.test(tckn)) {
                    errors.tckn = 'TCKN sadece rakamlardan oluşmalı';
                }
            }
        }
        if (requestType === 'kurye') {
            if (!formData.kuryeModel) {
                errors.kuryeModel = 'Kurye modeli zorunludur';
                console.log('Hata: kuryeModel');
            }
        }
        console.log('Validasyon bitti, errors:', errors);
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handlePromoClick = () => {
        console.log('Promosyon Clicked');
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) return;
    };

    const handleCancel = (request) => {
        setSelectedRequest(request);
        setCancelModalOpen(true);
    };

    const handleDelivery = (request) => {
        setSelectedRequest(request);
        setDeliveryModalOpen(true);
    };

    const confirmCancel = () => {
        if (selectedRequest && requestType) {
            const currentRequests = requestType === 'kargo' ? cargoRequests : courierRequests;
            const updatedRequests = currentRequests.map(req =>
                req.id === selectedRequest.id ? { ...req, status: 'İptal' } : req
            );
            if (requestType === 'kargo') {
                setCargoRequests(updatedRequests);
            } else {
                setCourierRequests(updatedRequests);
            }
            setCancelModalOpen(false);
        }
    };

    const confirmDelivery = () => {
        if (selectedRequest && requestType) {
            const currentRequests = requestType === 'kargo' ? cargoRequests : courierRequests;
            const updatedRequests = currentRequests.map(req =>
                req.id === selectedRequest.id ? { ...req, status: 'Tamamlandı' } : req
            );
            if (requestType === 'kargo') {
                setCargoRequests(updatedRequests);
            } else {
                setCourierRequests(updatedRequests);
            }
            setDeliveryModalOpen(false);
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'İptal': return '#DA3831';
            case 'Tamamlandı': return '#4CAF50';
            case 'Ödeme Bekleniyor': return '#FFA000';
            case 'Ödendi': return '#2196F3';
            default: return 'inherit';
        }
    };

    const shouldShowDeliveryButton = (request) => {
        return request.payment === 'Ödendi' &&
            request.status !== 'Tamamlandı' &&
            request.status !== 'İptal';
    };

    const filterActiveRequests = (reqList) => {
        return reqList.filter(req =>
            req.status !== 'Tamamlandı' && req.status !== 'İptal'
        );
    };

    const filterCompletedRequests = (reqList) => {
        return reqList.filter(req =>
            req.status === 'Tamamlandı' || req.status === 'İptal'
        );
    };

    const handlePayment = async () => {
        if (!validateForm()) return;
        setPaymentModalOpen(true);
    };

    const resetForm = () => {    
        /*    
        setFormData({
            gondericiAd: "",
            gondericiSoyad: "",
            telefon: "",
            email: "",
            tckn: "",
            bireyselKurumsal: "Bireysel",
            icerikKategori: "",
            paketAdedi: "",
            agirlik: "",
            city: "",
            district: "",
            town: "",
            aliciAdSoyad: "",
            aliciAd: "",
            aliciSoyad: "",
            aliciTelefon: "",
            gondericiCity: "",
            gondericiTown: "",
            gondericiAcikAdres: "",
            acikAdres: "",
            kuryeModel: "",
            adresTarifi: "",
            additionalNote: ""
        });
        */

        // YENİ: Kargo ile ilgili tüm state'leri sıfırla
        setCargoPackages([]);
        setCurrentPackage({ icerikKategori: '', agirlik: '', en: '', boy: '', yukseklik: '' });
        setCargoPriceDetails(null);
        setCargoLabelData(null);

        // Diğer genel state'leri sıfırla
        setSelectedRequestId(null);
        setVigoPriceDetails(null);
        setFormErrors({});
        setSelectedCompany('');
        setRequestType('');
        setIsPaymentCompleted(false);
        setStep(0);
    };

    const handleCalculateFee = async () => {
        if (!formData.acikAdres) {
            setFormErrors(prev => ({ ...prev, acikAdres: 'Açık adres girilmeden ücret hesaplanamaz.' }));
            return;
        }
        const address = `${formData.city} ${formData.district} ${formData.town} ${formData.acikAdres}`;
        const apiKey = "AIzaSyByvfX7mgCvxiti1aSmeZ3xs3-up0HWCB0";
        try {
            const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`);
            const data = await response.json();
            if (data.status === 'OK' && data.results.length > 0) {
                const location = data.results[0].geometry.location;
                setPendingLatLng(location);
                setShowLocationConfirmModal(true);
            } else {
                setAddressNotFoundModalOpen(true);
            }
        } catch (err) {
            setAddressNotFoundModalOpen(true);
        }
    };

    const handleMapLocationSelect = (latLng) => {
        setSelectedLatLng(latLng);
        setMapModalOpen(false);
    };

    const handleConfirmLocation = async () => {
        setSelectedLatLng(pendingLatLng);
        setShowLocationConfirmModal(false);
        setPendingLatLng(null);
        // Ücret hesaplama işlemi (sadece kurye için)
        if (requestType === 'kurye') {
            setIsCalculating(true);
            setVigoPriceDetails(null);
            try {
                // pointID: tokenService.getUser().firstResponsibleOffice.id,
                let pointID = tokenService.getUser().firstResponsibleOffice.id;
                const data = {
                    pointID,
                    receiver: {
                        address: formData.acikAdres,
                        location: {
                            longitude: pendingLatLng.lng,
                            latitude: pendingLatLng.lat
                        }
                    }
                };
                const res = await Services.calculateVigoPrice(data);
                if (res.data && res.data.status) {
                    setVigoPriceDetails(res.data.result);
                } else {
                    setVigoPriceDetails(null);
                    alert('Fiyat hesaplanamadı.');
                }
            } catch (e) {
                setVigoPriceDetails(null);
                alert('Fiyat hesaplanırken hata oluştu.');
            } finally {
                setIsCalculating(false);
            }
        }

        if (requestType === 'kargo') {
            setCargoPriceDetails({
                price: 100.00,
                estimatedDeliveryDate: '1-3 İş Günü'
            });
        }
    };
    const handleCancelLocation = () => {
        setShowLocationConfirmModal(false);
        setPendingLatLng(null);
    };

    function generateConversationID(requestType) { // Fonksiyon artık 'requestType' parametresi alıyor       
        const prefix = requestType === 'kurye' ? 'EPVG-' : 'EPKIST-';      
        const uniquePartLength = 20 - prefix.length;        
        const uniquePart = (
            Date.now().toString(36) + Math.random().toString(36).substr(2, 9)
        ).substr(0, uniquePartLength);        
        return `${prefix}${uniquePart}`;
    }

    const handleCashOrPosPayment = async (type) => {
        setPendingPaymentType(type);
        setCashPosModalOpen(true);
    };

    const handleConfirmCashPosPayment = async () => {
        setOrderLoading(true);
        setCashPosModalOpen(false);
        try {
            let pointID = tokenService.getUser().firstResponsibleOffice.id;
            const postData = {
                pointID,
                senderName: formData.gondericiAd,
                senderLastname: formData.gondericiSoyad,
                senderPhone: formData.telefon,
                senderEmail: formData.email,
                receiverNameLastname: formData.aliciAdSoyad,
                receiverAddressNeighbour: formData.town,
                receiverAddressTown: formData.district,
                receiverAddressCity: formData.city,
                receiverAddressDetails: formData.acikAdres,
                receiverAddressDefinition: formData.adresTarifi,
                receiverPhone: formData.aliciTelefon,
                price: vigoPriceDetails?.price || 0,
                longitude: selectedLatLng?.lng || '',
                latitude: selectedLatLng?.lat || '',
                productType: formData.icerikKategori,
                additionalNote: formData.additionalNote,
                courierType: formData.kuryeModel || 'MotorCourier',
                coupon: false,
                discountedPrice: 0
            };
            const vigoRes = await Services.createVigoPost(postData);
            setOrderLoading(false);
            if (vigoRes.data && vigoRes.data.status) {
                setIsPaymentCompleted(true);
                setStep(2);
                setPaymentType(pendingPaymentType);
                // orderNumber'ı gönderi kodu olarak kullan
                const orderNumber = vigoRes.data.result.orders && vigoRes.data.result.orders[0]?.orderNumber;
                console.log(vigoRes.data.result);
                setSelectedRequestId(orderNumber || vigoRes.data.result.orderIds?.[0] || '');
            } else {
                setShowErrorModal(true);
                setErrorMessage("Sipariş oluşturulamadı. Lütfen tekrar deneyin.");
            }
        } catch (e) {
            setOrderLoading(false);
            setShowErrorModal(true);
            setErrorMessage("Sipariş oluşturulurken hata oluştu. Lütfen tekrar deneyin.");
        }
    };

    // Talepleri API'den çekme fonksiyonu
    const fetchRequestsFromAPI = async () => {
        try {
            const pointID = tokenService.getUser()?.firstResponsibleOffice?.id;
            const res = await Services.GetThirdPartyCargoCourierPosts(pointID);
            if (res.data.status && Array.isArray(res.data.result)) {
                // Platforma göre ayır
                const courier = [];
                const cargo = [];
                res.data.result.forEach(item => {
                    // Platformu orders[0].platform veya dataJson.orders[0].platform'dan al
                    let platform = '';
                    if (item.dataJson && item.dataJson.orders && item.dataJson.orders[0]) {
                        platform = item.dataJson.orders[0].platform;
                    }
                    // Status mapping
                    let status = '';
                    let payment = '';
                    const deliveryState = item.resultJson?.deliveryState;
                    if (deliveryState === 'inQueue') {
                        status = 'Ödendi';
                        payment = 'Ödendi';
                    } else if (deliveryState === 'cancelled') {
                        status = 'İptal';
                        payment = 'Ödeme Bekleniyor';
                    } else if (deliveryState === 'delivered') {
                        status = 'Tamamlandı';
                        payment = 'Ödendi';
                    } else {
                        status = 'Ödeme Bekleniyor';
                        payment = 'Ödeme Bekleniyor';
                    }
                    // Tarih
                    let date = '';
                    if (item.createdDateTime) {
                        // createdDateTime epoch ise çevir
                        const d = new Date(Number(item.createdDateTime) * 1000);
                        date = d.toLocaleString('tr-TR');
                    }
                    // id/orderNumber
                    const id = item.orderNumber || item.id || (item.dataJson?.orders?.[0]?.orderNumber) || '';
                    const requestObj = {
                        id,
                        date,
                        status,
                        payment,
                        // Diğer gerekli alanlar eklenebilir
                        raw: item,
                    };
                    if (platform === 'Vigo') {
                        courier.push(requestObj);
                    } else if (platform === 'Kargoist') {
                        cargo.push(requestObj);
                    }
                });
                setCourierRequests(courier);
                setCargoRequests(cargo);
            } else {
                setCourierRequests([]);
                setCargoRequests([]);
            }
        } catch (e) {
            setCourierRequests([]);
            setCargoRequests([]);
        }
    };
    // Modal açıldığında API'den veri çek
    useEffect(() => {
        if (courierModalOpen) fetchRequestsFromAPI();
    }, [courierModalOpen]);
    useEffect(() => {
        if (cargoModalOpen) fetchRequestsFromAPI();
    }, [cargoModalOpen]);

    const handleCardNumberChange = (e) => {
        const rawValue = e.target.value.replace(/\s+/g, '');
        const numbersOnly = rawValue.replace(/[^0-9]/g, '');
        const truncated = numbersOnly.slice(0, 16);
        const formatted = truncated.replace(/(\d{4})/g, '$1 ').trim();

        setCardNumber(formatted);
    };

    const handleExpiryDateChange = (e) => {
        const rawValue = e.target.value.replace(/\s*\/\s*/g, '/');
        const numbersOnly = rawValue.replace(/[^0-9]/g, '');

        let truncated = numbersOnly.slice(0, 4);
        if (truncated.length > 0 && parseInt(truncated[0], 10) > 1) {
            truncated = `0${truncated}`;
        }
        if (truncated.length >= 2 && parseInt(truncated.substring(0, 2), 10) > 12) {
            truncated = `12${truncated.slice(2)}`;
        }
        if (truncated.length > 2) {
            const formatted = `${truncated.slice(0, 2)}/${truncated.slice(2)}`;
            setExpiredDate(formatted);
        } else {
            setExpiredDate(truncated);
        }
    };

    const handleCvvChange = (e) => {
        const numbersOnly = e.target.value.replace(/[^0-9]/g, '');
        const truncated = numbersOnly.slice(0, 3);
        setCvv(truncated);
    };

    function luhnCheck(cardNumber) {
        if (!/^\d+$/.test(cardNumber)) {
            return false;
        }
        let sum = 0;
        let shouldDouble = false;
        for (let i = cardNumber.length - 1; i >= 0; i--) {
            let digit = parseInt(cardNumber.charAt(i), 10);
            if (shouldDouble) {
                digit *= 2;
                if (digit > 9) digit -= 9;
            }
            sum += digit;
            shouldDouble = !shouldDouble;
        }
        return sum % 10 === 0;
    }

    const validatePaymentForm = () => {
        const errors = {};
        const now = new Date();
        const currentYear = now.getFullYear() % 100;
        const currentMonth = now.getMonth() + 1;

        if (!cardName.trim()) {
            errors.cardName = "Kart üzerindeki isim zorunludur.";
        }

        const cardNumberDigits = cardNumber.replace(/\s/g, '');

        if (!cardNumberDigits || cardNumberDigits.length < 13 || cardNumberDigits.length > 19) {
            errors.cardNumber = "Geçerli bir kart numarası giriniz.";
        } else if (!luhnCheck(cardNumberDigits)) {
            errors.cardNumber = "Geçersiz kart numarası. Lütfen kontrol ediniz.";
        }

        if (!expiredDate) {
            errors.expiredDate = "Son kullanma tarihi zorunludur.";
        } else {
            const [month, year] = expiredDate.split('/');
            if (!month || !year || month.length !== 2 || year.length !== 2) {
                errors.expiredDate = "Tarihi AA/YY formatında giriniz.";
            } else {
                const expYear = parseInt(year, 10);
                const expMonth = parseInt(month, 10);
                if (expYear < currentYear || (expYear === currentYear && expMonth < currentMonth)) {
                    errors.expiredDate = "Kartınızın son kullanma tarihi geçmiş.";
                }
            }
        }

        if (!cvv || cvv.length !== 3) {
            errors.cvv = "Geçerli bir 3 haneli CVV giriniz.";
        }

        setPaymentFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleProceedToPayment = () => {
        const isFormValid = validatePaymentForm();

        if (isFormValid) {            
            setConversationID(generateConversationID(requestType)); // requestType'e göre ID oluştur
        }
    };

    const handleCurrentPackageChange = (event) => {
        const { name, value } = event.target;
        setCurrentPackage(prev => ({ ...prev, [name]: value }));
    };

    // Doldurulan paketi listeye ekler ve formu temizler
    const handleAddPackage = () => {
        // Basit bir validasyon: Kategori ve ağırlık dolu mu?
        if (!currentPackage.icerikKategori || !currentPackage.agirlik) {
            alert('Lütfen paket bilgilerini (içerik ve ağırlık) eksiksiz doldurun.');
            return;
        }
        // Mevcut paketi listeye ekle
        setCargoPackages([...cargoPackages, currentPackage]);
        // Formu temizle
        setCurrentPackage({ icerikKategori: '', agirlik: '', en: '', boy: '', yukseklik: '' });
    };

    const handleCalculateCargoFee = () => {
        // Formun geçerli olup olmadığını kontrol et
        if (!validateForm()) {
            alert("Lütfen devam etmeden önce formdaki tüm zorunlu alanları doldurun.");
            return;
        }

        if (cargoPackages.length === 0) {
            alert("Lütfen en az bir paket ekleyin.");
            return;
        }

        const price = cargoPackages.length * 100;
        const totalDesi = cargoPackages.reduce((sum, pkg) => sum + (parseFloat(pkg.agirlik) || 0), 0);

        setCargoPriceDetails({
            price: price,
            packageCount: cargoPackages.length,
            totalDesi: totalDesi
        });
    };

    const handleDownloadPdf = () => {
        if (!cargoLabelData || !cargoLabelData.label) return;

        try {
            // Base64 string'ini byte dizisine çevir
            const byteCharacters = atob(cargoLabelData.label);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            // PDF için bir Blob oluştur
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);

            // Geçici bir link oluştur ve tıklayarak indirmeyi başlat
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${cargoLabelData.consignmentNumber}.pdf`); // Dosya adı gönderi numarası olacak
            document.body.appendChild(link);
            link.click();

            // Linki temizle
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error("PDF indirme hatası:", error);
            alert("PDF etiketi indirilirken bir hata oluştu.");
        }
    };

    // Listeden paket siler
    const handleRemovePackage = (indexToRemove) => {
        setCargoPackages(cargoPackages.filter((_, index) => index !== indexToRemove));
    };

    return (
        <Box p={4} bgcolor="#f9f9f9" minHeight="100vh">
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={4}
                pb={1}
                borderBottom="1px solid #EBEBEB"
            >
                <Box display="flex" alignItems="center" gap={2}>
                    <Box>
                        <Typography variant="h6" fontWeight={600}>
                            Kurye - Kargo
                        </Typography>
                        <Typography variant="body2" color="text.secondary" fontSize={14} mt={2}>
                            {step === 0
                                ? 'Kurye - Kargo işlemleri'
                                : requestType === 'kurye'
                                    ? 'Kurye Talebi Oluşturun'
                                    : 'Kargo Talebi Oluşturun'}
                        </Typography>
                    </Box>
                </Box>
                {step === 0 && (
                    <Chip
                        label="Bekleyen Talepler: 4"
                        color="error"
                        variant="outlined"
                        sx={{ fontWeight: 500, color: 'rgba(218, 56, 49, 1)', borderColor: 'rgba(255, 219, 217, 1)' }}
                    />
                )}
                {step !== 0 && step !== 2 && (
                    <Box sx={{ p: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: 'white', boxShadow: 1, borderRadius: 1 }}>
                        <IconButton
                            sx={{ width: '20px', height: '20px' }}
                            onClick={() => {
                                setStep(0);
                                setSelectedCompany('');
                                setRequestType('');
                            }}
                            color="inherit"
                        >
                            <ArrowBackIcon />
                        </IconButton>
                    </Box>
                )}
            </Box>

            {step === 0 && (
                <>
                    <Stack spacing={2} mb={6}>
                        <Button
                            variant="contained"
                            fullWidth
                            color="error"
                            startIcon={<DirectionsBikeIcon />}
                            sx={{ py: 2, fontWeight: 500, justifyContent: 'flex-start', backgroundColor: '#DA3831' }}
                            onClick={() => {
                                setRequestType('kurye');
                                setStep(1);
                            }}
                        >
                            Kurye Talebi Oluştur
                        </Button>
                        <Button
                            variant="contained"
                            fullWidth
                            color="error"
                            startIcon={<LocalShippingIcon />}
                            sx={{ py: 2, fontWeight: 500, justifyContent: 'flex-start', backgroundColor: '#DA3831' }}
                            onClick={() => {
                                setRequestType('kargo');
                                setStep(1);
                            }}
                        >
                            Kargo Talebi Oluştur
                        </Button>
                    </Stack>

                    <Typography variant="body2" color="text.secondary" mb={2}>
                        Kurye - Kargo Talepleri
                    </Typography>

                    <Stack spacing={2}>
                        <Button
                            variant="contained"
                            fullWidth
                            color="error"
                            startIcon={<DirectionsBikeIcon />}
                            sx={{ py: 2, fontWeight: 500, backgroundColor: '#DA3831', justifyContent: 'flex-start' }}
                            onClick={() => {
                                setCourierModalOpen(true)
                                setRequestType('kurye');
                            }}
                        >
                            Kurye Gönderi Talepleri
                        </Button>
                        <Button
                            variant="contained"
                            fullWidth
                            color="error"
                            startIcon={<LocalShippingIcon />}
                            sx={{ py: 2, fontWeight: 500, backgroundColor: '#DA3831', justifyContent: 'flex-start' }}
                            onClick={() => {
                                setCargoModalOpen(true)
                                setRequestType('kargo');
                            }}
                        >
                            Kargo Gönderi Talepleri
                        </Button>
                    </Stack>
                </>
            )}

            {step === 1 && (
                <Box display="flex" gap={4}>
                    <Box sx={{ flex: 1 }}>
                        <FormControl fullWidth sx={{ mb: 3 }}>
                            <InputLabel>Firma Seç</InputLabel>
                            <Select
                                value={selectedCompany}
                                label="Anlaşmalı Firma Seçiniz"
                                onChange={(e) => setSelectedCompany(e.target.value)}
                            >
                                {companies[requestType].map((company) => (
                                    <MenuItem key={company} value={company}>
                                        {company}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {selectedCompany && (
                            <Box component="form" onSubmit={handleSubmit} sx={{ bgcolor: '#fff', p: 3, borderRadius: 2, boxShadow: 1 }}>
                                <Stack spacing={3}>
                                    <Typography fontWeight={600} mb={1}>Gönderici Bilgileri</Typography>
                                    <Stack direction="row" spacing={2}>
                                        <Box flex={1}>
                                            <TextField
                                                name="gondericiAd"
                                                label="Gönderici Ad"
                                                value={formData.gondericiAd}
                                                onChange={handleFormChange}
                                                fullWidth
                                                size="medium"
                                                error={!!formErrors.gondericiAd}
                                                helperText={formErrors.gondericiAd}
                                            />
                                        </Box>
                                        <Box flex={1}>
                                            <TextField
                                                name="gondericiSoyad"
                                                label="Gönderici Soyad"
                                                value={formData.gondericiSoyad}
                                                onChange={handleFormChange}
                                                fullWidth
                                                size="medium"
                                                error={!!formErrors.gondericiSoyad}
                                                helperText={formErrors.gondericiSoyad}
                                            />
                                        </Box>
                                    </Stack>
                                    {requestType === "kargo" && (
                                        <Stack spacing={3}>
                                            <Stack direction='row' spacing={3}>
                                                <Box flex={1}>
                                                    <Select
                                                        name="gondericiCity"
                                                        value={formData.gondericiCity}
                                                        onChange={handleFormChange}
                                                        fullWidth
                                                        displayEmpty
                                                        inputProps={{ style: { height: 48, padding: '0 16px' } }}
                                                    >
                                                        <MenuItem value=""><em>Gönderici İl</em></MenuItem>
                                                        {cities.map((city) => (
                                                            <MenuItem key={city.code} value={city.name}>{city.name}</MenuItem>
                                                        ))}
                                                    </Select>
                                                    {formErrors.gondericiCity && <Typography color="error" fontSize={13}>{formErrors.city}</Typography>}
                                                </Box>
                                                <Box flex={1}>
                                                    <Select
                                                        name="gondericiTown"
                                                        value={formData.gondericiTown}
                                                        onChange={handleFormChange}
                                                        fullWidth
                                                        displayEmpty
                                                        inputProps={{ style: { height: 48, padding: '0 16px' } }}
                                                    >
                                                        <MenuItem value=""><em>Gönderici İlçe</em></MenuItem>
                                                        {gondericiTowns.map((town) => (
                                                            <MenuItem key={town.code} value={town.name}>{town.name}</MenuItem>
                                                        ))}
                                                    </Select>
                                                    {formErrors.gondericiTown && <Typography color="error" fontSize={13}>{formErrors.district}</Typography>}
                                                </Box>
                                            </Stack>
                                            <Box>
                                                <TextField
                                                    name="gondericiAcikAdres"
                                                    label="Gönderici Açık Adresi"
                                                    value={formData.gondericiAcikAdres}
                                                    onChange={handleFormChange}
                                                    fullWidth
                                                    size="medium"
                                                    multiline
                                                    minRows={3}
                                                    error={!!formErrors.gondericiAcikAdres}
                                                    helperText={formErrors.gondericiAcikAdres}
                                                />
                                            </Box>
                                        </Stack>
                                    )}
                                    <Stack direction="row" spacing={2}>
                                        <Box flex={1}>
                                            <TextField
                                                name="telefon"
                                                label="Telefon No"
                                                value={formData.telefon}
                                                onChange={handleFormChange}
                                                fullWidth
                                                size="medium"
                                                error={!!formErrors.telefon}
                                                helperText={formErrors.telefon}
                                            />
                                        </Box>
                                        <Box flex={1}>
                                            <TextField
                                                name="email"
                                                label="E-mail Adresi"
                                                value={formData.email}
                                                onChange={handleFormChange}
                                                fullWidth
                                                size="medium"
                                                error={!!formErrors.email}
                                                helperText={formErrors.email}
                                            />
                                        </Box>
                                    </Stack>
                                    {requestType === 'kargo' && (
                                        <Stack direction="row" spacing={2}>
                                            <Box flex={1}>
                                                <TextField
                                                    name="tckn"
                                                    label="TCKN No"
                                                    value={formData.tckn}
                                                    onChange={handleFormChange}
                                                    fullWidth
                                                    size="medium"
                                                />
                                            </Box>
                                            <Box flex={1}>
                                                <Select
                                                    name="bireyselKurumsal"
                                                    value={formData.bireyselKurumsal}
                                                    onChange={handleFormChange}
                                                    fullWidth
                                                    displayEmpty
                                                    inputProps={{ style: { height: 48, padding: '0 16px' } }}
                                                >
                                                    <MenuItem value="Bireysel">Bireysel Gönderi</MenuItem>
                                                    <MenuItem value="Kurumsal">Kurumsal Gönderi</MenuItem>
                                                </Select>
                                                {formErrors.bireyselKurumsal && <Typography color="error" fontSize={13}>{formErrors.bireyselKurumsal}</Typography>}
                                            </Box>
                                        </Stack>
                                    )}
                                    {requestType === 'kargo' && (
                                        <>
                                            <Stack spacing={3}>
                                                {/* PAKET GİRİŞ FORMU */}
                                                <Box p={2} border="1px solid #e0e0e0" borderRadius={2}>
                                                    <Typography variant="subtitle1" fontWeight={600} mb={2}>Paket Bilgileri</Typography>
                                                    <Stack spacing={2}>
                                                        <Stack direction='row' spacing={2}>
                                                            <FormControl fullWidth>
                                                                <InputLabel>İçerik Kategorisi</InputLabel>
                                                                <Select
                                                                    name="icerikKategori"
                                                                    value={currentPackage.icerikKategori}
                                                                    label="İçerik Kategorisi"
                                                                    onChange={handleCurrentPackageChange}
                                                                >
                                                                    <MenuItem value="Elektronik">Elektronik</MenuItem>
                                                                    <MenuItem value="Giyim">Giyim</MenuItem>
                                                                    <MenuItem value="Kitap">Kitap</MenuItem>
                                                                    <MenuItem value="Diğer">Diğer</MenuItem>
                                                                </Select>
                                                            </FormControl>
                                                            <TextField
                                                                name="agirlik"
                                                                label="Ağırlık / Desi"
                                                                type="number"
                                                                fullWidth
                                                                value={currentPackage.agirlik}
                                                                onChange={handleCurrentPackageChange}
                                                            />
                                                        </Stack>
                                                        <Stack direction="row" spacing={1}>
                                                            <TextField name="en" label="En (cm)" type="number" value={currentPackage.en} onChange={handleCurrentPackageChange} />
                                                            <TextField name="boy" label="Boy (cm)" type="number" value={currentPackage.boy} onChange={handleCurrentPackageChange} />
                                                            <TextField name="yukseklik" label="Yükseklik (cm)" type="number" value={currentPackage.yukseklik} onChange={handleCurrentPackageChange} />
                                                        </Stack>
                                                        <Button variant="contained" onClick={handleAddPackage} sx={{ mt: 1 }}>
                                                            Paket Ekle
                                                        </Button>
                                                    </Stack>
                                                </Box>

                                                {/* EKLENEN PAKETLER LİSTESİ */}
                                                {cargoPackages.length > 0 && (
                                                    <Box>
                                                        <Typography variant="subtitle1" fontWeight={600} mb={1}>Eklenen Paketler ({cargoPackages.length})</Typography>
                                                        <Stack spacing={1}>
                                                            {cargoPackages.map((pkg, index) => (
                                                                <Box
                                                                    key={index}
                                                                    display="flex"
                                                                    justifyContent="space-between"
                                                                    alignItems="center"
                                                                    p={1.5}
                                                                    border="1px solid #eee"
                                                                    borderRadius={1.5}
                                                                >
                                                                    <Typography variant="body2">
                                                                        {index + 1}. Paket: {pkg.icerikKategori} - {pkg.agirlik} kg/desi
                                                                        {pkg.en && ` - ${pkg.en}x${pkg.boy}x${pkg.yukseklik}cm`}
                                                                    </Typography>
                                                                    <IconButton size="small" onClick={() => handleRemovePackage(index)}>
                                                                        <CloseIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Box>
                                                            ))}
                                                        </Stack>
                                                    </Box>
                                                )}
                                            </Stack>
                                            <Stack direction="row" spacing={2}>
                                                <Box flex={1}>
                                                    <Select
                                                        name="city"
                                                        value={formData.city}
                                                        onChange={handleFormChange}
                                                        fullWidth
                                                        displayEmpty
                                                        inputProps={{ style: { height: 48, padding: '0 16px' } }}
                                                    >
                                                        <MenuItem value=""><em>Alıcı İl</em></MenuItem>
                                                        {cities.map((city) => (
                                                            <MenuItem key={city.code} value={city.name}>{city.name}</MenuItem>
                                                        ))}
                                                    </Select>
                                                    {formErrors.city && <Typography color="error" fontSize={13}>{formErrors.city}</Typography>}
                                                </Box>
                                                <Box flex={1}>
                                                    <Select
                                                        name="district"
                                                        value={formData.district}
                                                        onChange={handleFormChange}
                                                        fullWidth
                                                        displayEmpty
                                                        inputProps={{ style: { height: 48, padding: '0 16px' } }}
                                                    >
                                                        <MenuItem value=""><em>Alıcı İlçe</em></MenuItem>
                                                        {towns.map((town) => (
                                                            <MenuItem key={town.code} value={town.name}>{town.name}</MenuItem>
                                                        ))}
                                                    </Select>
                                                    {formErrors.district && <Typography color="error" fontSize={13}>{formErrors.district}</Typography>}
                                                </Box>
                                                <Box flex={1}>
                                                    <Select
                                                        name="town"
                                                        value={formData.town}
                                                        onChange={handleFormChange}
                                                        fullWidth
                                                        displayEmpty
                                                        inputProps={{ style: { height: 48, padding: '0 16px' } }}
                                                    >
                                                        <MenuItem value=""><em>Alıcı Mahalle</em></MenuItem>
                                                        {districts.map((district) => (
                                                            <MenuItem key={district.code} value={district.name}>{district.name}</MenuItem>
                                                        ))}
                                                    </Select>
                                                    {formErrors.town && <Typography color="error" fontSize={13}>{formErrors.town}</Typography>}
                                                </Box>
                                            </Stack>
                                            <Stack direction="row" spacing={2}>
                                                <Stack direction="row" spacing={2}>
                                                    <TextField
                                                        name="aliciAd"
                                                        label="Alıcı Adı"
                                                        value={formData.aliciAd}
                                                        onChange={handleFormChange}
                                                        fullWidth
                                                        size="medium"
                                                        error={!!formErrors.aliciAd}
                                                        helperText={formErrors.aliciAd}
                                                    />
                                                    <TextField
                                                        name="aliciSoyad"
                                                        label="Alıcı Soyadı"
                                                        value={formData.aliciSoyad}
                                                        onChange={handleFormChange}
                                                        fullWidth
                                                        size="medium"
                                                        error={!!formErrors.aliciSoyad}
                                                        helperText={formErrors.aliciSoyad}
                                                    />
                                                </Stack>
                                                <Box flex={1}>
                                                    <TextField
                                                        name="aliciTelefon"
                                                        label="Alıcı Telefon No"
                                                        value={formData.aliciTelefon}
                                                        onChange={handleFormChange}
                                                        fullWidth
                                                        size="medium"
                                                        error={!!formErrors.aliciTelefon}
                                                        helperText={formErrors.aliciTelefon}
                                                    />
                                                </Box>
                                            </Stack>
                                            <Box>
                                                <TextField
                                                    name="acikAdres"
                                                    label="Açık adres"
                                                    value={formData.acikAdres}
                                                    onChange={handleFormChange}
                                                    fullWidth
                                                    size="medium"
                                                    multiline
                                                    minRows={3}
                                                    error={!!formErrors.acikAdres}
                                                    helperText={formErrors.acikAdres}
                                                />
                                            </Box>
                                            <Box mt={2}>
                                                <TextField
                                                    name="additionalNote"
                                                    label="Notlar"
                                                    value={formData.additionalNote}
                                                    onChange={handleFormChange}
                                                    fullWidth
                                                    size="medium"
                                                    multiline
                                                    minRows={2}
                                                />
                                            </Box>
                                            <Box mt={2}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    fullWidth
                                                    onClick={handleCalculateCargoFee} // YENİ FONKSİYON
                                                    sx={{ fontWeight: 600, py: 1 }}
                                                >
                                                    Ücreti Hesapla
                                                </Button>
                                            </Box>
                                        </>
                                    )}
                                    {requestType === 'kurye' && (
                                        <>
                                            <Box>
                                                <InputLabel shrink>İçerik Kategorisi</InputLabel>
                                                <Select
                                                    name="icerikKategori"
                                                    value={formData.icerikKategori}
                                                    onChange={handleFormChange}
                                                    fullWidth
                                                    displayEmpty
                                                    inputProps={{ style: { height: 48, padding: '0 16px' } }}
                                                >
                                                    <MenuItem value=""><em>Seçiniz</em></MenuItem>
                                                    <MenuItem value="Elektronik">Elektronik</MenuItem>
                                                    <MenuItem value="Giyim">Giyim</MenuItem>
                                                    <MenuItem value="Kitap">Kitap</MenuItem>
                                                    <MenuItem value="Diğer">Diğer</MenuItem>
                                                </Select>
                                                {formErrors.icerikKategori && <Typography color="error" fontSize={13}>{formErrors.icerikKategori}</Typography>}
                                            </Box>
                                            <Stack direction="row" spacing={2}>
                                                <Box flex={1}>
                                                    <Select
                                                        name="city"
                                                        value={formData.city}
                                                        onChange={handleFormChange}
                                                        fullWidth
                                                        displayEmpty
                                                        inputProps={{ style: { height: 48, padding: '0 16px' } }}
                                                    >
                                                        <MenuItem value=""><em>Alıcı İl</em></MenuItem>
                                                        {cities.map((city) => (
                                                            <MenuItem key={city.code} value={city.name}>{city.name}</MenuItem>
                                                        ))}
                                                    </Select>
                                                    {formErrors.city && <Typography color="error" fontSize={13}>{formErrors.city}</Typography>}
                                                </Box>
                                                <Box flex={1}>
                                                    <Select
                                                        name="district"
                                                        value={formData.district}
                                                        onChange={handleFormChange}
                                                        fullWidth
                                                        displayEmpty
                                                        inputProps={{ style: { height: 48, padding: '0 16px' } }}
                                                    >
                                                        <MenuItem value=""><em>Alıcı İlçe</em></MenuItem>
                                                        {towns.map((town) => (
                                                            <MenuItem key={town.code} value={town.name}>{town.name}</MenuItem>
                                                        ))}
                                                    </Select>
                                                    {formErrors.district && <Typography color="error" fontSize={13}>{formErrors.district}</Typography>}
                                                </Box>
                                            </Stack>
                                            <Stack direction="row" spacing={2}>
                                                <Box flex={1}>
                                                    <Select
                                                        name="town"
                                                        value={formData.town}
                                                        onChange={handleFormChange}
                                                        fullWidth
                                                        displayEmpty
                                                        inputProps={{ style: { height: 48, padding: '0 16px' } }}
                                                    >
                                                        <MenuItem value=""><em>Alıcı Mahalle</em></MenuItem>
                                                        {districts.map((district) => (
                                                            <MenuItem key={district.code} value={district.name}>{district.name}</MenuItem>
                                                        ))}
                                                    </Select>
                                                    {formErrors.town && <Typography color="error" fontSize={13}>{formErrors.town}</Typography>}
                                                </Box>
                                                <Box flex={1}>
                                                    <Select
                                                        name="kuryeModel"
                                                        value={formData.kuryeModel}
                                                        onChange={handleFormChange}
                                                        fullWidth
                                                        displayEmpty
                                                        inputProps={{ style: { height: 48, padding: '0 16px' } }}
                                                    >
                                                        <MenuItem value=""><em>Kurye Modeli Seçiniz</em></MenuItem>
                                                        <MenuItem value="MotorCourier">Moto Kurye</MenuItem>
                                                    </Select>
                                                    {formErrors.kuryeModel && <Typography color="error" fontSize={13}>{formErrors.kuryeModel}</Typography>}
                                                </Box>
                                            </Stack>
                                            <Stack direction="row" spacing={2}>
                                                <Box flex={1}>
                                                    <TextField
                                                        name="aliciAdSoyad"
                                                        label="Alıcı Ad Soyad"
                                                        value={formData.aliciAdSoyad}
                                                        onChange={handleFormChange}
                                                        fullWidth
                                                        size="medium"
                                                        error={!!formErrors.aliciAdSoyad}
                                                        helperText={formErrors.aliciAdSoyad}
                                                    />
                                                </Box>
                                                <Box flex={1}>
                                                    <TextField
                                                        name="aliciTelefon"
                                                        label="Alıcı Telefon No"
                                                        value={formData.aliciTelefon}
                                                        onChange={handleFormChange}
                                                        fullWidth
                                                        size="medium"
                                                        error={!!formErrors.aliciTelefon}
                                                        helperText={formErrors.aliciTelefon}
                                                    />
                                                </Box>
                                            </Stack>
                                            <Box>
                                                <TextField
                                                    name="acikAdres"
                                                    label="Açık adres"
                                                    value={formData.acikAdres}
                                                    onChange={handleFormChange}
                                                    fullWidth
                                                    size="medium"
                                                    multiline
                                                    minRows={3}
                                                    error={!!formErrors.acikAdres}
                                                    helperText={formErrors.acikAdres}
                                                />
                                            </Box>
                                            <Box mt={2}>
                                                <TextField
                                                    name="adresTarifi"
                                                    label="Adres Tarifi"
                                                    value={formData.adresTarifi}
                                                    onChange={handleFormChange}
                                                    fullWidth
                                                    size="medium"
                                                    multiline
                                                    minRows={2}
                                                />
                                            </Box>
                                            <Box mt={2}>
                                                <TextField
                                                    name="additionalNote"
                                                    label="Notlar"
                                                    value={formData.additionalNote}
                                                    onChange={handleFormChange}
                                                    fullWidth
                                                    size="medium"
                                                    multiline
                                                    minRows={2}
                                                />
                                            </Box>
                                            {/* Ücreti Hesapla ve Haritadan Seç Butonları */}
                                            <Box mt={2} display="flex" gap={2}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleCalculateFee}
                                                    sx={{ fontWeight: 600, width: '100%', py: 1 }}
                                                >
                                                    Ücreti Hesapla
                                                </Button>
                                                <Button
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={() => setMapModalOpen(true)}
                                                    sx={{ fontWeight: 600, width: '100%', py: 1 }}
                                                >
                                                    Haritadan Seç
                                                </Button>
                                            </Box>
                                            {/* Konum Bulunamadı Modalı */}
                                            <Dialog open={addressNotFoundModalOpen} onClose={() => setAddressNotFoundModalOpen(false)}>
                                                <DialogTitle>Konum Bulunamadı</DialogTitle>
                                                <DialogContent>
                                                    <Typography>Açık adresinizden konum bulamadık, lütfen haritadan bir konum seçiniz.</Typography>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={() => {
                                                        setAddressNotFoundModalOpen(false);
                                                        setMapModalOpen(true);
                                                    }} color="primary" variant="contained">Haritadan Seç</Button>
                                                    <Button onClick={() => setAddressNotFoundModalOpen(false)} color="inherit">Vazgeç</Button>
                                                </DialogActions>
                                            </Dialog>
                                            {/* Konum Onay Modalı */}
                                            <Dialog open={showLocationConfirmModal} onClose={handleCancelLocation} maxWidth="md" fullWidth>
                                                <DialogTitle>Seçtiğiniz Nokta</DialogTitle>
                                                <DialogContent sx={{ height: 400, position: 'relative' }}>
                                                    <Typography mb={2}>Seçtiğiniz nokta haritada gösterilmiştir. Onaylıyor musunuz?</Typography>
                                                    <Box sx={{ width: '100%', height: 350 }}>
                                                        {pendingLatLng && (
                                                            <GoogleMapSelector
                                                                onLocationSelect={(newLatLng) => setPendingLatLng(newLatLng)}
                                                                initialLocation={pendingLatLng}
                                                                initialAddress={''}
                                                            />
                                                        )}
                                                    </Box>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={handleConfirmLocation} color="primary" variant="contained">Onayla</Button>
                                                    <Button onClick={handleCancelLocation} color="inherit">Vazgeç</Button>
                                                </DialogActions>
                                            </Dialog>
                                            {/* Harita Modalı */}
                                            <Dialog open={mapModalOpen} onClose={() => setMapModalOpen(false)} maxWidth="md" fullWidth>
                                                <DialogTitle>Konum Seç</DialogTitle>
                                                <DialogContent sx={{ height: 400, position: 'relative' }}>
                                                    <Box sx={{ width: '100%', height: 400 }}>
                                                        <GoogleMapSelector
                                                            onLocationSelect={handleMapLocationSelect}
                                                            initialLocation={selectedLatLng}
                                                            initialAddress={`${formData.city} ${formData.district} ${formData.town}`}
                                                        />
                                                    </Box>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={() => setMapModalOpen(false)} color="inherit">Kapat</Button>
                                                </DialogActions>
                                            </Dialog>
                                        </>
                                    )}
                                </Stack>
                            </Box>
                        )}
                    </Box>
                    {selectedCompany && (
                        <Box>
                            <Box sx={{
                                width: 340,
                                bgcolor: 'rgba(243, 243, 243, 1)',
                                p: 3,
                                borderRadius: 2,
                                boxShadow: 'none',
                                border: 'none',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1.5,
                                minWidth: 320,
                            }}>
                                <Typography fontWeight={500} color="#B0B0B0" fontSize={17} mb={1}>Ücret Detayları</Typography>
                                {/* Kurye için fiyat hesaplanana kadar boş */}
                                {requestType === 'kurye' && !vigoPriceDetails && !isCalculating && (
                                    <Typography color="text.secondary" fontSize={16} mb={2}>Ücret hesaplanmadı.</Typography>
                                )}
                                {requestType === 'kurye' && isCalculating && (
                                    <Typography color="text.secondary" fontSize={16} mb={2}>Hesaplanıyor...</Typography>
                                )}
                                {requestType === 'kurye' && vigoPriceDetails && (
                                    <>
                                        <Typography fontSize={32} fontWeight={700} color="#191919" mb={1}>{vigoPriceDetails.price} TL</Typography>
                                        <Box mb={1.5}>
                                            <Typography fontWeight={700} fontSize={16} color="#23272E">Mesafe</Typography>
                                            <Typography fontWeight={500} fontSize={15} color="#23272E">{vigoPriceDetails.detail.distance} km</Typography>
                                        </Box>
                                        <Box mb={1.5}>
                                            <Typography fontWeight={700} fontSize={16} color="#23272E" mb={0.5}>Detay</Typography>
                                            <Box display="flex" justifyContent="space-between" fontSize={15} color="#23272E">
                                                <Box>Mesafe Ücreti</Box>
                                                <Box>{vigoPriceDetails.detail.distancePrice} TL</Box>
                                            </Box>
                                            <Box display="flex" justifyContent="space-between" fontSize={15} color="#23272E">
                                                <Box>Paket Ücreti</Box>
                                                <Box>{vigoPriceDetails.detail.packagePrice} TL</Box>
                                            </Box>
                                            <Box display="flex" justifyContent="space-between" fontSize={15} color="#23272E">
                                                <Box>Ekstra Mesafe</Box>
                                                <Box>{vigoPriceDetails.detail.extraDistance} km</Box>
                                            </Box>
                                        </Box>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" fontSize={15} color="#23272E" mb={0.5}>
                                            <Typography fontWeight={600}>KDV</Typography>
                                            <Typography fontWeight={600}>0.00 TL</Typography>
                                        </Box>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" fontSize={18} color="#23272E" mb={1.5}>
                                            <Typography fontWeight={700}>TOPLAM</Typography>
                                            <Typography fontWeight={700} color="#DA3831">{vigoPriceDetails.price} TL</Typography>
                                        </Box>
                                    </>
                                )}
                                {requestType === 'kargo' && cargoPriceDetails && (
                                    <>
                                        {/* Toplam Fiyat */}
                                        <Typography fontSize={32} fontWeight={700} color="#191919" mb={1}>
                                            {cargoPriceDetails.price.toFixed(2)} TL
                                        </Typography>

                                        {/* Paket Sayısı */}
                                        <Box mb={1.5}>
                                            <Typography fontWeight={700} fontSize={16} color="#23272E">Paket Detayları</Typography>
                                            <Box display="flex" justifyContent="space-between" fontSize={15} color="#23272E">
                                                <Box>Paket Sayısı</Box>
                                                <Box>{cargoPriceDetails.packageCount} Adet</Box>
                                            </Box>
                                            <Box display="flex" justifyContent="space-between" fontSize={15} color="#23272E">
                                                <Box>Toplam Desi</Box>
                                                <Box>{cargoPriceDetails.totalDesi}</Box>
                                            </Box>
                                        </Box>

                                        {/* Promosyon ve Toplam Alanları */}
                                        <Box mb={1.5}>
                                            <input style={{ width: '100%', padding: '14px 12px', border: '1px solid #D0D5DD', borderRadius: 8, fontSize: 16, marginBottom: 10 }} placeholder="Promosyon Kodu" />
                                            <Button variant="outlined" color="error" onClick={handlePromoClick} sx={{ width: '100%', borderRadius: 1.5, fontWeight: 600, fontSize: 18, py: 1.2, borderColor: '#DA3831', color: '#DA3831', mb: 1 }}>
                                                Uygula
                                            </Button>
                                        </Box>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" fontSize={15} color="#23272E" mb={0.5}>
                                            <Typography fontWeight={600}>KDV</Typography>
                                            <Typography fontWeight={600}>0.00 TL</Typography>
                                        </Box>
                                        <Box display="flex" justifyContent="space-between" alignItems="center" fontSize={18} color="#23272E" mb={1.5}>
                                            <Typography fontWeight={700}>TOPLAM</Typography>
                                            <Typography fontWeight={700} color="#DA3831">{cargoPriceDetails.price.toFixed(2)} TL</Typography>
                                        </Box>
                                    </>
                                )}

                                {/* Kargo için henüz fiyat hesaplanmadıysa gösterilecek mesaj */}
                                {requestType === 'kargo' && !cargoPriceDetails && (
                                    <Typography color="text.secondary" fontSize={16} mb={2}>
                                        Lütfen paket bilgilerini girip ücreti hesaplayın.
                                    </Typography>
                                )}
                            </Box>
                            <Button fullWidth variant="contained" color="error" sx={{ mt: 2, backgroundColor: '#DA3831', borderRadius: 1.5, fontWeight: 600, fontSize: 20, py: 1.5, fontSize: 14 }} type="button" onClick={handlePayment}
                                disabled={
                                    (requestType === 'kurye' && !vigoPriceDetails) ||
                                    (requestType === 'kargo' && !cargoPriceDetails)
                                }>
                                Ödemeye Geç
                            </Button>
                            {/* Nakit ve Fiziki Pos Butonları */}
                            <Button fullWidth variant="outlined" color="success" sx={{ mt: 1, borderRadius: 1.5, fontWeight: 600, fontSize: 16, py: 1.2 }} onClick={() => handleCashOrPosPayment('cash')}>Nakit Ödeme</Button>
                            <Button fullWidth variant="outlined" color="info" sx={{ mt: 1, borderRadius: 1.5, fontWeight: 600, fontSize: 16, py: 1.2 }} onClick={() => handleCashOrPosPayment('credit-card')}>Fiziki Pos</Button>
                        </Box>
                    )}
                </Box>
            )}

            {step === 2 && isPaymentCompleted && (
                <Box sx={{ borderRadius: 2, p: 4, mx: 'auto', mt: 4 }}>
                    <Box backgroundColor="#FFF" border="1px solid rgba(233, 233, 233, 1)" p={1.5} borderRadius={1.5} display="flex" alignItems="center" mb={2}>
                        <Box sx={{ borderRadius: '50%', width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 3 }}>
                            <Box component="img" src="/assets/checkmark.png" alt="Checkmark" />
                        </Box>
                        <Typography fontWeight={600} color="#000">Gönderiniz Başarıyla Oluşturulmuştur.</Typography>
                    </Box>
                    <Box sx={{ borderRadius: 2, p: 3, mb: 3, boxShadow: 1 }}>
                        <Box display="grid" gridTemplateColumns="1fr 1fr" flexWrap="wrap" gap={3} mb={2}>
                            <Box flex={1} minWidth={220}>
                                <Typography>Gönderi Kodu</Typography>
                                <Typography fontWeight={600}>{selectedRequestId}</Typography>
                            </Box>
                            <Box flex={1} minWidth={220}>
                                <Typography>Gönderi Firması</Typography>
                                <Typography fontWeight={600}>{requestType === 'kargo' ? 'Kargoist' : 'Vigo'}</Typography>
                            </Box>
                            <Box flex={1} minWidth={220}>
                                <Typography>Paket Adedi</Typography>
                                <Typography fontWeight={600}>
                                    {requestType === 'kargo' ? cargoPackages.length : '1'} Adet
                                </Typography>
                            </Box>
                            <Box flex={1} minWidth={220}>
                                <Typography>İçerik Kategorisi</Typography>
                                <Typography fontWeight={600}>
                                    {requestType === 'kargo' ? (cargoPackages[0]?.icerikKategori || 'Çoklu Ürün') : formData.icerikKategori}
                                </Typography>
                            </Box>
                            <Box flex={1} minWidth={220}>
                                <Typography>Oluşturulma Tarihi</Typography>
                                <Typography fontWeight={600}>{new Date().toLocaleString('tr-TR')}</Typography>
                            </Box>

                            {requestType === 'kargo' && cargoPriceDetails && (
                                <Box flex={1} minWidth={220}>
                                    <Typography>Toplam Desi</Typography>
                                    <Typography fontWeight={600}>{cargoPriceDetails.totalDesi} Desi</Typography>
                                </Box>
                            )}
                        </Box>

                        <Box mb={2}>
                            <Typography fontWeight={600}>Teslimat Adresi</Typography>
                            <Typography>
                                {summaryAddress || [formData.city, formData.district, formData.town, formData.acikAdres].filter(Boolean).join(' / ')}
                            </Typography>
                        </Box>

                        <Box mb={2}>
                            <Typography fontWeight={600}>Toplam Tutar</Typography>
                            <Typography color="#DA3831" fontWeight={700} fontSize={20}>
                                {requestType === 'kargo'
                                    ? `${cargoPriceDetails?.price.toFixed(2)} TL`
                                    : `${vigoPriceDetails?.price} TL`
                                }
                            </Typography>
                        </Box>

                        {paymentType && (
                            <Box mb={2}>
                                <Typography fontWeight={600}>Ödeme Tipi</Typography>
                                <Typography>{paymentType}</Typography>
                            </Box>
                        )}

                        {/* Sadece Kargo için PDF İndirme Butonu */}
                        {requestType === 'kargo' && cargoLabelData && (
                            <Button
                                variant="outlined"
                                onClick={handleDownloadPdf}
                                sx={{ my: 2, width: '100%', py: 1 }}
                            >
                                PDF Etiketi İndir
                            </Button>
                        )}

                        <Button fullWidth variant="contained" color="error" sx={{ mt: 2, backgroundColor: '#DA3831', borderRadius: 1.5, fontWeight: 600, fontSize: 14, py: 1.5 }} onClick={resetForm}>
                            Yeni Gönderi Oluştur
                        </Button>
                    </Box>
                </Box>
            )}

            <Dialog
                open={cargoModalOpen}
                onClose={() => setCargoModalOpen(false)}
                maxWidth="sm"
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '460px',
                        width: '100%'
                    }
                }}
            >
                <DialogTitle sx={{ p: 2 }}>
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <Typography variant="h6" textAlign='center'>Kargo Talepleri</Typography>
                        <IconButton
                            onClick={() => setCargoModalOpen(false)}
                            sx={{ position: 'absolute', right: 8, top: 8 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent sx={{ p: 2 }}>
                    <Tabs
                        value={activeTab}
                        onChange={(e, newValue) => setActiveTab(newValue)}
                        TabIndicatorProps={{ style: { display: 'none' } }}
                        sx={{
                            mb: 2,
                            justifyContent: 'center',
                            '& .MuiTabs-flexContainer': {
                                backgroundColor: 'rgba(255, 239, 239, 1)',
                                borderRadius: '8px 8px',
                                p: .5,
                                gap: .5,
                                maxWidth: '340px',
                                mx: 'auto',
                                justifyContent: 'center'
                            },
                        }}
                    >
                        <Tab
                            label="Aktif Talepler"
                            value="active"
                            sx={{
                                flex: 1,
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: 13,
                                borderRadius: '8px 8px',
                                backgroundColor: activeTab === 'active' ? '#fff' : 'transparent',
                                color: activeTab === 'active' ? 'rgba(52, 64, 84, 1)' : 'rgba(133, 108, 102, 1)',
                                boxShadow: activeTab === 'active' ? '0 -2px 4px rgba(0,0,0,0.1)' : 'none',
                                px: 2,
                                py: 1.5,
                                minWidth: 'auto',
                            }}
                        />
                        <Tab
                            label="Tamamlanan Talepler"
                            value="completed"
                            sx={{
                                flex: 1,
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: 13,
                                borderRadius: '8px 8px',
                                backgroundColor: activeTab === 'completed' ? '#fff' : 'transparent',
                                color: activeTab === 'completed' ? 'rgba(52, 64, 84, 1)' : 'rgba(133, 108, 102, 1)',
                                boxShadow: activeTab === 'completed' ? '0 -2px 4px rgba(0,0,0,0.1)' : 'none',
                                px: 2,
                                py: 1.5,
                                minWidth: 'auto',
                            }}
                        />
                    </Tabs>
                    <Stack spacing={2}>
                        {(activeTab === 'active'
                            ? filterActiveRequests(cargoRequests)
                            : filterCompletedRequests(cargoRequests)).map((request) => (
                                <Box key={request.id} p={2} border="1px solid #EBEBEB" borderRadius={2} position='relative'>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Typography fontWeight={600}>Kargoist Gönderim Talebi</Typography>
                                        <Box>
                                            {shouldShowDeliveryButton(request) && (
                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    size="small"
                                                    sx={{ backgroundColor: '#DA3831', width: '100%', maxWidth: '100px', padding: '10px 20px', position: 'absolute', bottom: '8px', right: '14px' }}
                                                    onClick={() => handleDelivery(request)}
                                                >
                                                    Teslim Al
                                                </Button>
                                            )}
                                            {request.status !== 'Tamamlandı' && request.status !== 'İptal' && (
                                                <Box sx={{ position: 'absolute' }} backgroundColor="rgba(237, 236, 236, 1)" borderRadius='50%' right="14px" top="14px" display="flex">
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleCancel(request)}
                                                        disabled={request.status === 'İptal' || request.status === 'Tamamlandı'}
                                                    >
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            )}
                                        </Box>

                                    </Box>

                                    <Typography variant="body2">Gönderi Kodu: {request.id}</Typography>
                                    <Typography variant="body2">Tarih: {request.date}</Typography>
                                    <Typography variant="body2">
                                        Durum: <span style={{ color: getStatusColor(request.status) }}>{request.status}</span>
                                    </Typography>
                                </Box>
                            ))}
                    </Stack>
                </DialogContent>
            </Dialog>

            <Dialog
                open={courierModalOpen}
                onClose={() => setCourierModalOpen(false)}
                maxWidth="sm"
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '460px',
                        width: '100%',
                        pt: 4,
                        pb: 8,
                    },
                }}
            >
                <DialogTitle sx={{ p: 2 }}>
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <Typography variant="h6">Kurye Talepleri</Typography>
                        <IconButton
                            onClick={() => setCourierModalOpen(false)}
                            sx={{ position: 'absolute', right: 8, top: 8 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent sx={{ p: 2 }}>
                    <Tabs
                        value={activeTab}
                        onChange={(e, newValue) => setActiveTab(newValue)}
                        TabIndicatorProps={{ style: { display: 'none' } }}
                        sx={{
                            mb: 2,
                            justifyContent: 'center',
                            '& .MuiTabs-flexContainer': {
                                backgroundColor: 'rgba(255, 239, 239, 1)',
                                borderRadius: '8px 8px',
                                p: .5,
                                gap: .5,
                                maxWidth: '340px',
                                mx: 'auto',
                                justifyContent: 'center'
                            },
                        }}
                    >
                        <Tab
                            label="Aktif Talepler"
                            value="active"
                            sx={{
                                flex: 1,
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: 13,
                                borderRadius: '8px 8px',
                                backgroundColor: activeTab === 'active' ? '#fff' : 'transparent',
                                color: activeTab === 'active' ? 'rgba(52, 64, 84, 1)' : 'rgba(133, 108, 102, 1)',
                                boxShadow: activeTab === 'active' ? '0 -2px 4px rgba(0,0,0,0.1)' : 'none',
                                px: 2,
                                py: 1.5,
                                minWidth: 'auto',
                            }}
                        />
                        <Tab
                            label="Tamamlanan Talepler"
                            value="completed"
                            sx={{
                                flex: 1,
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: 13,
                                borderRadius: '8px 8px',
                                backgroundColor: activeTab === 'completed' ? '#fff' : 'transparent',
                                color: activeTab === 'completed' ? 'rgba(52, 64, 84, 1)' : 'rgba(133, 108, 102, 1)',
                                boxShadow: activeTab === 'completed' ? '0 -2px 4px rgba(0,0,0,0.1)' : 'none',
                                px: 2,
                                py: 1.5,
                                minWidth: 'auto',
                            }}
                        />
                    </Tabs>
                    <Stack spacing={2} position="relative">
                        {(activeTab === 'active'
                            ? filterActiveRequests(courierRequests)
                            : filterCompletedRequests(courierRequests)).map((request) => (
                                <Box key={request.id} p={2} border="1px solid #EBEBEB" borderRadius={2} position='relative'>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Typography fontWeight={600}>Vigo Gönderim Talebi</Typography>
                                        <Box>
                                            {shouldShowDeliveryButton(request) && (
                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    size="small"
                                                    sx={{ backgroundColor: '#DA3831', width: '100%', maxWidth: '100px', padding: '10px 20px', position: 'absolute', bottom: '8px', right: '14px' }}
                                                    onClick={() => handleDelivery(request)}
                                                >
                                                    Teslim Al
                                                </Button>
                                            )}
                                            {request.status !== 'Tamamlandı' && (
                                                <Box sx={{ position: 'absolute' }} backgroundColor="rgba(237, 236, 236, 1)" borderRadius='50%' right="14px" top="14px" display="flex">
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleCancel(request)}
                                                        disabled={request.status === 'İptal' || request.status === 'Tamamlandı'}
                                                    >
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            )}
                                        </Box>

                                    </Box>
                                    <Typography variant="body2">Gönderi Kodu: {request.id}</Typography>
                                    <Typography variant="body2">Tarih: {request.date}</Typography>
                                    <Typography variant="body2">
                                        Durum: <span style={{ color: getStatusColor(request.status) }}>{request.status}</span>
                                    </Typography>
                                </Box>
                            ))}
                    </Stack>
                </DialogContent>
            </Dialog>

            <Dialog open={deliveryModalOpen} onClose={() => setDeliveryModalOpen(false)}
                maxWidth="sm"
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '460px',
                        width: '100%',
                        py: 2.5,
                    },
                }}
            >
                <DialogTitle>
                    <Box sx={{
                        backgroundColor: 'rgba(250, 232, 220, 1)',
                        border: '8px solid rgba(253, 244, 236, 1)',
                        width: 'fit-content',
                        padding: 1.5,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        {requestType === 'kargo' ?
                            <LocalShippingIcon sx={{ color: '#DA3831', width: 22 }} /> :
                            <DirectionsBikeIcon sx={{ color: '#DA3831', width: 22 }} />
                        }
                    </Box>
                    <Typography variant='h4' sx={{ fontSize: '18px' }}>{requestType === 'kargo' ? 'Kargoist Gönderi Teslim Alma Onayı' : 'Vigo Gönderi Teslim Alma Onayı'}</Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography sx={{
                        fontSize: '14px',
                        color: 'rgba(71, 84, 103, 1)'
                    }}>
                        "{selectedRequest?.id}" Nolu müşteri gönderisini teslim alma işlemini <strong>onaylıyor musunuz?</strong>
                    </Typography>
                </DialogContent>
                <DialogActions sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1,
                    px: 2,
                }}>
                    <Button sx={{
                        backgroundColor: '#DA3831',
                        color: 'white',
                        width: '100%',
                        fontSize: '16px',
                        textAlign: 'center',
                        py: 1.5,
                        marginLeft: '0 !important'
                    }} onClick={confirmDelivery} color="error" variant="contained">
                        Onayla
                    </Button>
                    <Button sx={{
                        width: '100%',
                        fontSize: '16px',
                        textAlign: 'center',
                        color: 'rgba(52, 64, 84, 1)',
                        border: '1px solid rgba(208, 213, 221, 1)',
                        marginLeft: '0 !important',
                        py: 1.5
                    }} onClick={() => setDeliveryModalOpen(false)} color="inherit">
                        Vazgeç
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={cancelModalOpen} onClose={() => setCancelModalOpen(false)} maxWidth="sm"
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '460px',
                        width: '100%',
                        py: 2.5,
                        '& .MuiDialog-paper .MuiTypography-root': {
                            paddingInline: '0 !important',
                        }
                    },
                }}>
                <DialogTitle>
                    <Box sx={{
                        backgroundColor: 'rgba(250, 232, 220, 1)',
                        border: '8px solid rgba(253, 244, 236, 1)',
                        width: 'fit-content',
                        padding: 1.5,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        {requestType === 'kargo' ?
                            <LocalShippingIcon sx={{ color: '#DA3831', width: 22 }} /> :
                            <DirectionsBikeIcon sx={{ color: '#DA3831', width: 22 }} />
                        }
                    </Box>
                    <Typography variant='h4' sx={{
                        fontSize: '18px',
                    }}>{requestType === 'kargo' ? 'Kargoist İşlem İptal Onayı' : 'Vigo İşlem İptal Onayı'}</Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography sx={{
                        fontSize: '14px',
                        color: 'rgba(71, 84, 103, 1)'
                    }}>
                        "{selectedRequest?.id}" Nolu müşteri gönderisi için {requestType === 'kargo' ? 'kargo' : 'kurye'} çağırma işleminin iptalini <strong>onaylıyor musunuz?</strong>
                    </Typography>
                </DialogContent>
                <DialogActions sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1,
                    px: 2,
                }}>
                    <Button sx={{
                        backgroundColor: '#DA3831',
                        color: 'white',
                        width: '100%',
                        fontSize: '16px',
                        textAlign: 'center',
                        py: 1.5,
                        marginLeft: '0 !important'
                    }} onClick={confirmCancel} color="error" variant="contained">
                        Onayla
                    </Button>
                    <Button sx={{
                        width: '100%',
                        fontSize: '16px',
                        textAlign: 'center',
                        color: 'rgba(52, 64, 84, 1)',
                        border: '1px solid rgba(208, 213, 221, 1)',
                        py: 1.5,
                        marginLeft: '0 !important',
                    }} onClick={() => setCancelModalOpen(false)} color="inherit">
                        Vazgeç
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Ödeme Modalı */}
            <Dialog open={paymentModalOpen} onClose={() => setPaymentModalOpen(false)} maxWidth="xs" fullWidth>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', px: '24px', pt: '16px' }}>
                    <DialogTitle sx={{ padding: 0 }}>Ödeme Bilgileri</DialogTitle>
                    <img src='/assets/logo.png' width={50} height={50} />
                </Box>
                <DialogContent>
                    {iframeSrc ? (
                        <Box display="flex" justifyContent="center" alignItems="center" minHeight={400}>
                            <iframe
                                src={iframeSrc}
                                title="3D Secure"
                                style={{
                                    width: "420px",
                                    height: "520px",
                                    maxWidth: "95vw",
                                    maxHeight: "80vh",
                                    border: "none",
                                    borderRadius: "12px",
                                    boxShadow: "0 2px 16px rgba(0,0,0,0.12)",
                                    backgroundColor: '#fff',
                                    display: 'block',
                                }}
                            />
                        </Box>
                    ) : paymentTokenLoading ? (
                        <Box py={4} textAlign="center">Ödeme için hazırlanıyor...</Box>
                    ) : paymentTokenError ? (
                        <Box py={4} color="error.main" textAlign="center">{paymentTokenError}</Box>
                    ) : (
                        <Box display="flex" flexDirection="column" gap={2} mt={1}>
                            <TextField
                                label="Kart Üzerindeki İsim"
                                fullWidth
                                value={cardName}
                                onChange={e => setCardName(e.target.value)}
                                // Hata gösterme eklendi
                                error={!!paymentFormErrors.cardName}
                                helperText={paymentFormErrors.cardName}
                            />

                            <TextField
                                label="Kart Numarası"
                                fullWidth
                                value={cardNumber}
                                onChange={handleCardNumberChange} // Formatlama fonksiyonu
                                placeholder="0000 0000 0000 0000"
                                inputProps={{ maxLength: 19, inputMode: 'numeric' }}
                                // Hata gösterme eklendi
                                error={!!paymentFormErrors.cardNumber}
                                helperText={paymentFormErrors.cardNumber}
                            />

                            <Box display="flex" gap={2}>
                                <TextField
                                    label="Son Kullanma Tarihi"
                                    fullWidth
                                    value={expiredDate}
                                    onChange={handleExpiryDateChange} // Formatlama fonksiyonu
                                    placeholder="AA/YY"
                                    inputProps={{ maxLength: 5, inputMode: 'numeric' }}
                                    // Hata gösterme eklendi
                                    error={!!paymentFormErrors.expiredDate}
                                    helperText={paymentFormErrors.expiredDate}
                                />
                                <TextField
                                    label="CVV"
                                    fullWidth
                                    value={cvv}
                                    onChange={handleCvvChange} // Formatlama fonksiyonu
                                    placeholder="123"
                                    inputProps={{ maxLength: 3, inputMode: 'numeric' }}
                                    // Hata gösterme eklendi
                                    error={!!paymentFormErrors.cvv}
                                    helperText={paymentFormErrors.cvv}
                                />
                            </Box>
                        </Box>
                    )}
                    {/* Success Modal */}
                    <Dialog open={showSuccessModal} onClose={() => setShowSuccessModal(false)}>
                        <DialogTitle>Ödeme Başarılı</DialogTitle>
                        <DialogContent>
                            <Box py={2} textAlign="center">Ödemeniz başarıyla tamamlandı. Yönlendiriliyorsunuz...</Box>
                        </DialogContent>
                    </Dialog>
                    {/* Error Modal */}
                    <Dialog open={showErrorModal} onClose={() => setShowErrorModal(false)}>
                        <DialogTitle>Ödeme Başarısız</DialogTitle>
                        <DialogContent>
                            <Box py={2} textAlign="center">{errorMessage}</Box>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setShowErrorModal(false)} color="primary">Kapat</Button>
                        </DialogActions>
                    </Dialog>
                </DialogContent>
                <DialogActions>
                    {!iframeSrc && (
                        <>
                            <Button onClick={() => setPaymentModalOpen(false)} color="inherit">İptal</Button>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={paymentTokenLoading || !!paymentTokenError || iframeSrc}
                                // onClick olayı yeni fonksiyonla değiştirildi
                                onClick={handleProceedToPayment}
                            >
                                Ödemeyi Tamamla
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>
            <Dialog open={orderLoading} maxWidth="xs" fullWidth>
                <DialogTitle>Siparişiniz oluşturuluyor...</DialogTitle>
                <DialogContent>
                    <Box py={4} textAlign="center">Lütfen bekleyiniz.</Box>
                </DialogContent>
            </Dialog>
            {/* Nakit/Fiziki Pos Modal */}
            <Dialog open={cashPosModalOpen} onClose={() => setCashPosModalOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Ödeme Onayı</DialogTitle>
                <DialogContent>
                    <Typography mb={2}>
                        Sayın Yetkili,<br />
                        Lütfen müşterimizden ödemeyi alın. Eğer ödemeyi aldıysanız aşağıdaki butona tıklayarak gönderiyi kaydedebilirsiniz.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setCashPosModalOpen(false)} color="inherit">Vazgeç</Button>
                    <Button variant="contained" color="primary" onClick={handleConfirmCashPosPayment}>
                        Ödeme Alınmıştır
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}

function GoogleMapSelector({ onLocationSelect, initialLocation, initialAddress }) {
    const mapRef = useRef(null);
    const markerRef = useRef(null);
    const [mapLoaded, setMapLoaded] = React.useState(false);
    const [center, setCenter] = React.useState(initialLocation || { lat: 41.0082, lng: 28.9784 });
    const apiKey = "AIzaSyByvfX7mgCvxiti1aSmeZ3xs3-up0HWCB0";

    // Google Maps script yükle
    React.useEffect(() => {
        if (!window.google) {
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
            script.async = true;
            script.onload = () => setMapLoaded(true);
            document.body.appendChild(script);
        } else {
            setMapLoaded(true);
        }
    }, []);

    // initialAddress değişirse, geocode et ve harita merkezini güncelle
    React.useEffect(() => {
        if (!mapLoaded || !initialAddress) return;
        (async () => {
            try {
                const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(initialAddress)}&key=${apiKey}`);
                const data = await response.json();
                if (data.status === 'OK' && data.results.length > 0) {
                    const location = data.results[0].geometry.location;
                    setCenter(location);
                }
            } catch (e) { /* ignore */ }
        })();
    }, [mapLoaded, initialAddress]);

    // Haritayı ve marker'ı oluştur
    React.useEffect(() => {
        if (!mapLoaded) return;
        const map = new window.google.maps.Map(mapRef.current, {
            center: center,
            zoom: 14,
        });
        let marker = new window.google.maps.Marker({
            position: center,
            map,
            draggable: true,
        });
        markerRef.current = marker;
        map.addListener('click', (e) => {
            marker.setPosition(e.latLng);
            onLocationSelect({ lat: e.latLng.lat(), lng: e.latLng.lng() });
        });
        marker.addListener('dragend', (e) => {
            onLocationSelect({ lat: e.latLng.lat(), lng: e.latLng.lng() });
        });
    }, [mapLoaded, center]);

    return <div ref={mapRef} style={{ width: '100%', height: 400 }} />;
}
